import { render } from "./AdminDashboardView.vue?vue&type=template&id=c79cffaa&scoped=true"
import script from "./AdminDashboardView.vue?vue&type=script&lang=js"
export * from "./AdminDashboardView.vue?vue&type=script&lang=js"

import "./AdminDashboardView.vue?vue&type=style&index=0&id=c79cffaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c79cffaa"]])

export default __exports__